<template>
  <div>
    <div>
      <!-- SECTION HEADLINE -->
      <div class="section-light" id="sectionTitle">
        <b-container>
          <b-row>
            <b-col></b-col>
            <b-col sm="12" md="10">
              <div class="sectionHeadline">
                <h1>Activities</h1>
                <p>Side pursuits I’m involved in during my downtime</p>
              </div>
            </b-col>
            <b-col></b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- CLUBS & ORGANIZATIONS -->
    <content-section theme="dark">
      <b-row>
        <b-col class="text-center">
          <h1>Clubs &amp; Organizations</h1>
          <p>
            A few communities I joined to explore new interests and meet great
            people
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!-- CLUBS 1 -->
          <info-card theme="dark">
            <h2 slot="title">Google Developer Group Kuala Lumpur (GDGKL)</h2>
            <p slot="tagline">
              Sharing insights on development trends, personal experiences, and
              practical tips with fellow developers
            </p>
            <b-carousel slot="custom-carousel" controls indicators>
              <b-carousel-slide
                v-for="(item, i) in googleDeveloperCarousel"
                :key="i"
                :img-src="item.src"
              >
              </b-carousel-slide>
            </b-carousel>
            <div slot="description">
              <p>
                This is a developer group where we get together to talk about
                current tech trends, new implementation techniques, and the
                future of technology. Lots of technical discussions—but always
                interesting and worth following.
              </p>
              <p class="highlighted">Member since Apr 2018 - Jan 2020</p>
            </div>
          </info-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!-- CLUBS 2 -->
          <info-card theme="dark">
            <h2 slot="title">Toastmasters International</h2>
            <p slot="tagline">Where leaders are made</p>
            <b-img
              center
              slot="custom-image"
              :src="toastmastersImage"
              fluid
              alt="Toastmasters International"
            ></b-img>
            <div slot="description">
              <p>
                As the saying goes, a great leader needs to be a great
                communicator. I joined the Toastmasters club to learn how to
                deliver impactful speeches and overcome my fear of public
                speaking.
              </p>
              <p>
                Fun fact: Most people fear public speaking more than death—so I
                figured it was a good place to start.
              </p>
              <p class="highlighted">Member since Nov 2017 - Jan 2020</p>
            </div>
          </info-card>
        </b-col>
      </b-row>
    </content-section>
    <!-- VOLUNTEERING -->
    <content-section theme="light">
      <b-row>
        <b-col class="text-center">
          <h1>Volunteering</h1>
          <p>
            A small way of giving back and making a positive impact in the
            community
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!-- VOLUNTEERING 1 -->
          <info-card>
            <h2 slot="title">Indonesia Independence Day (2018)</h2>
            <p slot="tagline">
              Celebrating our motherland’s independence—no matter where we are
            </p>
            <b-carousel slot="custom-carousel" controls indicators>
              <b-carousel-slide
                v-for="(item, i) in indonesiaIndependenceCarousel"
                :key="i"
                :img-src="item.src"
              >
              </b-carousel-slide>
            </b-carousel>
            <div slot="description">
              <p>
                Indonesia’s Independence Day falls on August 17. Even though
                we’re currently studying in Malaysia, we believe that no matter
                where we are, it’s important to celebrate our Independence Day
                and honor our roots.
              </p>
              <p class="highlighted">Role: Logistic volunteer</p>
            </div>
          </info-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!-- VOLUNTEERING 2 -->
          <info-card>
            <h2 slot="title">Kuala Lumpur Marathon (2018)</h2>
            <p slot="tagline">
              Whether it’s 5km or 10km, it’s all about showing up and pushing
              forward
            </p>
            <b-carousel slot="custom-carousel" controls indicators>
              <b-carousel-slide
                v-for="(item, i) in kualaLumpurMarathonCarousel"
                :key="i"
                :img-src="item.src"
              >
              </b-carousel-slide>
            </b-carousel>
            <div slot="description">
              <p>
                An annual marathon held in Kuala Lumpur, attracting everyone
                from professional athletes to casual runners looking to enjoy
                the experience. I joined as part of the logistics volunteer
                team—helping set up the track and providing water to runners
                along the way.
              </p>
              <p class="highlighted">Role: Logistic volunteer</p>
            </div>
          </info-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!-- VOLUNTEERING 3 -->
          <info-card>
            <h2 slot="title">Rumah Solehah Project (2018)</h2>
            <p slot="tagline">
              Restructuring the orphanage to show the children they are cared
              for
            </p>
            <b-carousel slot="custom-carousel">
              <b-carousel-slide
                v-for="(item, i) in rumahSolehahCarousel"
                :key="i"
                :img-src="item.src"
              >
              </b-carousel-slide>
            </b-carousel>
            <div slot="description">
              <p>
                This was a community service project to help restructure an
                orphanage in Kuala Lumpur, Malaysia. Multiple teams were
                assigned different tasks to improve the space and facilities.
                Out of respect for the children’s privacy, we weren’t allowed to
                take any photos during the activity.
              </p>
              <p class="highlighted">Role: Volunteer team leader</p>
            </div>
          </info-card>
        </b-col>
      </b-row>
    </content-section>
    <!-- FOOTER -->
    <footer-section theme="dark"></footer-section>
  </div>
</template>

<script>
import InformationCard from "@/components/InformationCard";
import ContentSection from "../components/ContentSection.vue";

export default {
  name: "Activities",
  components: {
    "info-card": InformationCard,
    "content-section": ContentSection,
  },
  data() {
    return {
      // Image source link
      toastmastersImage: require("@/assets/common/images/icon/activities/toastmasters.png"),

      // Carousel source link
      googleDeveloperCarousel: [
        {
          src: require("@/assets/common/images/activity/gdgkl-meetup-april-1.png"),
        },
        {
          src: require("@/assets/common/images/activity/gdgkl-meetup-april-2.png"),
        },
      ],
      indonesiaIndependenceCarousel: [
        {
          src: require("@/assets/common/images/certificate/indonesia-independence-day.png"),
        },
        {
          src: require("@/assets/common/images/activity/indonesia-independence-day-2018.png"),
        },
      ],
      kualaLumpurMarathonCarousel: [
        {
          src: require("@/assets/common/images/certificate/kl-marathon-2018.png"),
        },
        {
          src: require("@/assets/common/images/activity/kl-marathon-1-2018.png"),
        },
        {
          src: require("@/assets/common/images/activity/kl-marathon-2-2018.png"),
        },
      ],
      rumahSolehahCarousel: [
        {
          src: require("@/assets/common/images/certificate/apu-rumah-solehah.png"),
        },
      ],
    };
  },
};
</script>

<style scoped>
div#sectionTitle {
  height: 500px;
  line-height: 460px;
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
    url("./../assets/common/images/activity/activity-headline.png");
  filter: grayscale(1);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  text-align: center;
  color: white;
  padding-bottom: 0;
  padding-top: 0;
}

.sectionHeadline {
  display: inline-block;
  vertical-align: middle;
  line-height: normal;
}
</style>
